import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { TransferCommissionService } from '../shared/services/transferCommission.service'
import { ExcelService } from '../shared/services/excel.service'
import { AdminService } from '../shared/services/admin.service'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { TopbarComponent } from '../shared/components/topbar/topbar.component'
import { SidebarComponent } from '../shared/components/sidebar/sidebar.component'
import { BottombarComponent } from '../shared/components/bottombar/bottombar.component'
import { InitializeTransferCommissionComponent } from './initializeTransferCommission/initialize-transfer-commission.component'
import { NgxPaginationModule } from 'ngx-pagination'

@Component({
    selector: 'app-transfer-commission',
    templateUrl: './transfer-commission.component.html',
    styleUrls: ['./transfer-commission.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        RouterModule,
        NgxPaginationModule,
        TopbarComponent,
        SidebarComponent,
        BottombarComponent,
        InitializeTransferCommissionComponent
    ]
})
export class TransferCommissionComponent implements OnInit {
  transferLogs: any[] = []
  errorMessage: string = ''
  pagination = {}
  config: any
  title: string
  details: any
  emptyTransactionMessage = 'Transfer commission log is empty.'

  constructor (
    private transferCommissionService: TransferCommissionService,
    private excelService: ExcelService,
    private adminService: AdminService
  ) {}

  ngOnInit () {
    this.getDetails()
    this.getTransferLogs()
  }

  getDetails () {
    this.adminService.getDetails().subscribe(data => {
      this.details = data[0]
    })
  }

  // getTransferLogs() {
  //   this.transferCommissionService.getAllTransferCommissionLogs().subscribe({
  //     next: (data) => {
  //       this.transferLogs = data;

  //       console.log('this is data', data)
  //     },
  //     error: (error) => {
  //       this.errorMessage = 'Error fetching transfer logs';
  //       console.error('Error:', error);
  //     }
  //   });
  // }

  handleTransferDetailLogs (event: { transferLogs: any[]; config: any }) {
    this.transferLogs = event.transferLogs
    this.config = event.config
    // Handle the received transferLogs and config here
  }

  getTransferLogs () {
    this.transferCommissionService
      .getAllTransferCommissionLogs()
      .subscribe(response => {
        this.transferLogs = response.data
        this.config = {
          itemsPerPage: 10,
          currentPage: 1,
          totalItems: response.data.length
        }
      })
  }

  exportReports () {
    const reports: any[] = []

    this.transferLogs.forEach(
      ({
        account_bank,
        account_number,
        amount,
        beneficiary_name,
        created_at,
        currency,
        message,
        narration,
        reference,
        status,
        transaction_id,
        updated_at
      }) =>
        reports.push({
          account_bank,
          account_number,
          amount,
          beneficiary_name,
          created_at,
          currency,
          message,
          narration,
          reference,
          status,
          transaction_id,
          updated_at
        })
    )

    this.excelService.exportAsExcelFile(
      reports,
      'icashremit transfer commission report'
    )
  }

  pageChanged (event: any) {
    this.config.currentPage = event
  }
}
